import { render, staticRenderFns } from "./classifyGoods.vue?vue&type=template&id=7dc6a60b&scoped=true&"
import script from "./classifyGoods.vue?vue&type=script&lang=js&"
export * from "./classifyGoods.vue?vue&type=script&lang=js&"
import style0 from "./classifyGoods.vue?vue&type=style&index=0&id=7dc6a60b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc6a60b",
  null
  
)

export default component.exports